import type { Staff } from '@/types'

export const STAFF_PER_PAGE = 10

export const statusBadgeVariant: Record<
  Staff['status'],
  'default' | 'secondary' | 'destructive' | 'outline'
> = {
  ACTIVE: 'default',
  ON_LEAVE: 'secondary',
  TERMINATED: 'destructive',
}
